import * as React from "react";
import { observer } from "mobx-react-lite";
import {
  Notification as NotificationModel,
  LEVEL_SUCCESS,
  notificationStore,
} from "lib/store";
import { Button, Toast, ToastContainer } from "react-bootstrap";

export const Notification = observer(() => {
  const store = notificationStore;

  const onClose = (notification: NotificationModel) => {
    store.notifications = store.notifications.filter((_) => _ != notification);
  };

  return (
    <ToastContainer
      className="p-3"
      position={store.position}
      containerPosition="fixed"
      style={{ zIndex: 100 }}
    >
      {store.notifications.map((notification, index) => (
        <Toast
          key={index}
          show
          delay={notification.timeout}
          autohide={!!notification.timeout}
          bg={notification.level === LEVEL_SUCCESS ? "success" : "danger"}
          onClose={() => onClose(notification)}
          style={{
            width: "initial",
            maxWidth: "50vw",
            wordBreak: "break-word",
          }}
        >
          {notification.title ? (
            <>
              <Toast.Header>
                <div className="me-auto">{notification.title}</div>
              </Toast.Header>
              <Toast.Body className="text-white">
                {notification.message}
              </Toast.Body>
            </>
          ) : (
            <div className="d-flex">
              <Toast.Body className="text-white">
                {notification.message}
              </Toast.Body>
              <Button
                className="btn-close me-2 m-auto"
                onClick={() => onClose(notification)}
              />
            </div>
          )}
        </Toast>
      ))}
    </ToastContainer>
  );
});
